import { deleteCookie, getCookie, setCookie } from '@beef/utils';
import { useEffect, useRef } from 'react';
import { CAPTCHA_BLOCKED_TIMEOUT_KEY } from "../../../../../config";
export var useFSMBlocker = function useFSMBlocker(_ref) {
  var onActivate = _ref.onActivate,
    onReached = _ref.onReached,
    zoneType = _ref.zoneType;
  var timeoutRef = useRef();
  var onBlockEnd = function onBlockEnd() {
    onReached === null || onReached === void 0 || onReached();
    deleteCookie(CAPTCHA_BLOCKED_TIMEOUT_KEY);
  };
  var activateBlocking = function activateBlocking(params) {
    var timeout = params.timeout,
      _params$withSetCookie = params.withSetCookie,
      withSetCookie = _params$withSetCookie === void 0 ? true : _params$withSetCookie;
    if (timeout) {
      onActivate === null || onActivate === void 0 || onActivate();
      if (withSetCookie) {
        // TODO: когда будет поддержка у всех браузеров перевести на browser.cookies.onChanged
        // Уставляем время блокировки
        setCookie({
          name: CAPTCHA_BLOCKED_TIMEOUT_KEY,
          value: (new Date().getTime() + timeout).toString(),
          maxAge: timeout
        });
      }
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(onBlockEnd, timeout);
    }
  };
  useEffect(function () {
    var time = Number(getCookie(CAPTCHA_BLOCKED_TIMEOUT_KEY));
    var currentTime = new Date().getTime();
    if (time && zoneType === 'unauthorized' && currentTime < time) {
      activateBlocking({
        timeout: time - currentTime
      });
      return;
    }
    if (time <= currentTime) {
      onBlockEnd();
    }
  }, [zoneType]);
  useEffect(function () {
    return function () {
      return clearTimeout(timeoutRef.current);
    };
  }, []);
  return activateBlocking;
};